import { render, staticRenderFns } from "./Key.vue?vue&type=template&id=0aeab1aa&scoped=true&"
import script from "./Key.vue?vue&type=script&lang=js&"
export * from "./Key.vue?vue&type=script&lang=js&"
import style0 from "./Key.vue?vue&type=style&index=0&id=0aeab1aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeab1aa",
  null
  
)

export default component.exports